import { Component } from '@angular/core';
import { PdfService } from 'src/app/services/pdf.service';
@Component({
  selector: 'app-pdf-viewer-test',
  templateUrl: './pdf-viewer-test.component.html',
  styleUrls: ['./pdf-viewer-test.component.scss']
})
export class PdfViewerTestComponent  {

  constructor(private PdfService: PdfService) { }
}
